var collapsible_list_component_default = {
  "ltr": "-JlEM",
  "rtl": "_1jpYD",
  "iconContainer": "_3vWf7",
  "icon": "o39fJ",
  "isExpanded": "yMQQs",
  "listDimensions": "H0zFn"
};
export {
  collapsible_list_component_default as default
};
//# sourceMappingURL=collapsible-list-component-scss.js.map
